/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-09-18 18:18:31
 * @FilePath: \baishu_react_ui\src\components\dash\BsyDashImage\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import BsyDashBase from "../BsyDashBase";
import { BsyUtils } from "../../../utils/Utils";
import "./index.css";

class BsyDashImage extends BsyDashBase {
  constructor(props) {
    super(props);
    this.state = {
      style: {},
    };
  }

  componentDidMount() {
    // super.componentDidMount();
    if (this.props.getContext) {
      this.props.getContext(this);
    }
    const { styles } = this.props;
    if (styles) {
      if (styles.background.type === "image") {
        let val = "url(" + styles.background.image + ")";
        if (styles.background.position === "stretch") {
          val = val + " 0% 0% / 100% 100%";
        } else {
          val = val + " center center / cover";
        }
        this.setState({
          style: { background: val },
        });
      } else {
        this.setState({
          style: { background: styles.background.color },
        });
      }
    } else {
      this.setState({
        style: {},
      });
    }
  }

  loadData = (n, d) => {
    BsyUtils.applyFunc(this, this.props.onLoadSuccess, [{}, n, d], !1);
  };

  openImage = () => {
    const { imageContent, appId, entryId } = this.props;
 
    imageContent.linkValue
      ? BsyUtils.redirectTo(imageContent.linkValue, "_blank")
      : new window.FX.FilePreview({
          widgetType: "image",
          files: [imageContent.image],
          appId: appId,
          formId: entryId,
        });
  };

  render() {
    const { imageContent } = this.props;
    const url = BsyUtils.getfiledownloadURL(imageContent.image, {});
    return (
      <div
        className={
          "BsyDashImage " +
          imageContent.position +
          (imageContent.linkValue || imageContent.image ? " visit-mode" : "")
        }
        style={{
          "backgroundImage": imageContent.image
            ? url
            : "",
        }}
        onClick={this.openImage}
      />
    );
  }
}

export default BsyDashImage;
